import type { IndustryDetail } from "@/types/industryDetail";
import { industriesA } from "@/data/industryDetails.a";
import { industriesB } from "@/data/industryDetails.b";

export const industryDetails: IndustryDetail[] = [...industriesA, ...industriesB];

const bySlug = new Map(industryDetails.map((i) => [i.slug, i]));

export function getIndustryDetail(slug?: string): IndustryDetail | undefined {
  return slug ? bySlug.get(slug) : undefined;
}
